export default __webpack_public_path__ + "ca937183ff277efb38d0e6a3808c6dab.png";